import type { BaseQueue } from '..';

export enum AnalyticsEvents {
  // FUNNEL
  PUBLISH_SHOW = 'PUBLISH_SHOW',
  COMPLETED_PROFILE = 'COMPLETED_PROFILE',
  CREATED_PERSONAL_RESIDENCE = 'CREATED_PERSONAL_RESIDENCE',
  CREATED_COMMERCIAL_SPACE = 'CREATED_COMMERCIAL_SPACE',
  CREATED_COMMUNITY_SPACE = 'CREATED_COMMUNITY_SPACE',

  // MISC.,
  CLICKED_BUTTON = 'CLICKED_BUTTON',
  CREATED_ACCOUNT = 'CREATED_ACCOUNT',
  PURCHASED_TICKET = 'PURCHASED_TICKET',
  VIEWED_PAGE = 'VIEWED_PAGE',
  VIEWED_SHOW = 'VIEWED_SHOW',

  RELOADED_APP = 'RELOADED_APP',

  // BACK END
  CREATED_CONNECTION = 'CREATED_CONNECTION',
  CREATED_SHOW = 'CREATED_SHOW',
  REFUNDED_TICKET = 'REFUNDED_TICKET',
  SAVED_DETAILS_SECTION = 'SAVED_DETAILS_SECTION',
  SAVED_TICKETS_SECTION = 'SAVED_TICKETS_SECTION',
  SAVED_SPLIT_SECTION = 'SAVED_SPLIT_SECTION',
  CONFIRMED_SHOW = 'CONFIRMED_SHOW',
  CANCELLED_SHOW = 'CANCELLED_SHOW',
  COMPLETED_SHOW = 'COMPLETED_SHOW',
  EXPIRED_SHOW_CALL = 'EXPIRED_SHOW_CALL',
  RECEIVED_SHOW_CALL_IMPRESSION = 'RECEIVED_SHOW_CALL_IMPRESSION',
  RECEIVED_SHOW_CALL_SHARE = 'RECEIVED_SHOW_CALL_SHARE',
  RECEIVED_SHOW_CALL_RESPONSE = 'RECEIVED_SHOW_CALL_RESPONSE',

  // EMAIL
  DELIVERED_EMAIL = 'DELIVERED_EMAIL',
  OPENED_EMAIL = 'OPENED_EMAIL',
  CLICKED_EMAIL = 'CLICKED_EMAIL',
}

export interface AnalyticsDispatch extends BaseQueue {
  readonly event: AnalyticsEvents;
  readonly properties?: Record<string, any>;
  readonly userId: string;
}
